/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import createStore from './src/state/createStore';
import * as navigation from './src/state/ducks/navigation';

let store;

exports.replaceRouterComponent = ({ history }) => {
  store = createStore();

  const ConnectedRouterWrapper = ({ children }) => (
    <Provider store={store}>
      <Router history={history}>{children}</Router>
    </Provider>
  );

  return ConnectedRouterWrapper;
};

exports.onRouteUpdate = () => {
  // https://www.gatsbyjs.org/docs/browser-apis/#onRouteUpdate
  if (store) {
    store.dispatch(navigation.actionCreators.close());
  }
};



// WEBPACK FOOTER //
// ./gatsby-browser.js